import { getAuthAxiosBackend } from "../helpers/axios"

class BlogServices{

    constructor(){
    }

    get(id){
        return getAuthAxiosBackend().get( 'blogs' + '/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('blogs', {params: data})
    }

    add(post){
        return getAuthAxiosBackend().post('blogs', post)
    }

    edit(id, post){
        post.append('_method', 'put')
        return getAuthAxiosBackend().post('blogs' + '/' + id, post)
    }

    delete(id){
        return getAuthAxiosBackend().delete('blogs' + '/' + id)
    }
}

export default new BlogServices()